module.exports = __webpack_public_path__ + "img/icon_yen_black.0e3acc3e.svg";